/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import RaisedButton from 'material-ui/RaisedButton';
import FontIcon from 'material-ui/FontIcon';

class Panel extends React.Component {

    constructor(props) {
        super(props);
        this.clearWorkOrderDetail = this
            .clearWorkOrderDetail
            .bind(this);
    }

    clearWorkOrderDetail(e) {
        const { orderId, detailKey, clearWorkOrderDetail } = this.props;

        e.preventDefault();
        clearWorkOrderDetail(orderId, detailKey, detailKey === 'equipmentDetails');
    }

    render() {
        const {
            loading,
            hasDetails,
            children,
            showRefreshButton,
            paddingLeft,
            paddingRight
        } = this.props;

        let headerComponent = null,
            noDetailsMessage = null,
            loadingMessage = null;

        if (showRefreshButton) {

            const refreshIcon = (
                <FontIcon className="material-icons">refresh</FontIcon>
            );

            headerComponent = (
                <div>

                    <RaisedButton
                        label="Refresh"
                        icon={refreshIcon}
                        primary={true}
                        onTouchTap={this.clearWorkOrderDetail} />

                </div>
            );
        }

        if (loading) {

            loadingMessage = (
                <div className="wow-fst-loading-message">Loading...</div>
            );
        }

        if (!hasDetails && !loading) {
            noDetailsMessage = (
                <div className="row">

                    <div className="col s6">
                        <h6>No Details to Display</h6>
                    </div>

                </div>

            );
        }

        return (

            <ReactCSSTransitionGroup
                component="div"
                style={{
                    paddingLeft: paddingLeft || '8px',
                    paddingRight: paddingRight || '8px',
                    overflowX: 'hidden'
                }}
                transitionName="card"
                transitionAppear={true}
                transitionAppearTimeout={500}
                transitionEnter={false}
                transitionLeaveTimeout={500}
                transitionLeave={true}>
                <span>
                    {headerComponent}
                    {noDetailsMessage}
                    {loadingMessage}
                    <div
                        ref={(childContainerDiv) => {
                            this.childContainerDiv = childContainerDiv;
                        }}>
                        {children}
                    </div>
                </span>

            </ReactCSSTransitionGroup>

        );
    }
}

Panel.propTypes = {
    loading: PropTypes.bool,
    hasDetails: PropTypes.bool,
    orderId: PropTypes.string,
    detailKey: PropTypes.string,
    clearWorkOrderDetail: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    showRefreshButton: PropTypes.bool,
    paddingLeft: PropTypes.string,
    paddingRight: PropTypes.string
};
export default Panel;



// WEBPACK FOOTER //
// ./src/components/panels/Panel.js